<template>
  <div id="func-10-detalhe">
    <funcionalidade-header :titulo="tituloNavegacao"/>
    <div v-if="idGuia">
      <extrato-detalhe/>
    </div>
    <div v-else>
      <solicitacao-detalhe/>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoDetalhe from '@/components/TemplateSolicitacao/componentes/SolicitacaoDetalhe'
import ExtratoDetalhe from '@/components/TemplateSolicitacao/componentes/ExtratoDetalhe'
import { mapState } from 'vuex'
export default {
  components: { SolicitacaoDetalhe, FuncionalidadeHeader, ExtratoDetalhe },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    idGuia () {
      return this.$route.query.idGuia
    }
  }
}
</script>
